import type { WiwState } from '@/store';

export const getReportDateRangeName = (state: WiwState): string => state.reporting.customReportBuilder.dateRangeName;
